<template>
  <loader v-if="isLoading"></loader>
  <div v-else-if="!isLoading && items.length < 1">
    {{ $t('views.userdata.list.noUserdatas') }}
  </div>
  <div v-else>
    <table class="table table-sm table-striped table-hover">
      <thead>
      <tr>
        <th></th>
        <th>{{$t('views.firm.show.userDataEmployee.options.userShow')}}</th>
        <th>{{$t('views.userdata.list.nameAndSurname')}}</th>
        <th>{{$t('views.userdata.show.hiredIn')}}</th>
        <th>{{$t('views.userdata.list.mobilePhone')}}</th>
        <th>{{$t('views.userdata.list.userEmail')}}</th>
        <th>{{$t('views.userdata.form.idClientType')}}</th>
        <th v-if="displayWorkplace">{{$t('views.userdatafirm.form.employeePosition')}}</th>
        <th v-if="displaySalesRepresentative">{{$t('views.userdata.form.idSalesRepresentative')}}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items" :key="item['@id']">
        <td class="text-center">
          <b-form-checkbox
            v-model="selectedUsers"
            :id="'checkbox_'+item['@id']"
            :value="item['@id']"
          ></b-form-checkbox>
        </td>
        <td class="text-left">
          <i v-if="item.users.length > 0" style="color: #28a745" class="fa fa-check-circle"></i>
          <i v-else class="fa fa-times-circle" style="color: #dc3545"></i>
        </td>
        <td>
          <router-link
            :to="{name: 'UserDataShow', params: { id: item['@id'] }}">
            {{ item.fullName }}
          </router-link>
        </td>
        <td>
          <router-link v-if="item.userDataFirms && item.userDataFirms.length > 0" :to="{name: 'FirmShow', params: { id: item.userDataFirms[0].firm['@id'] }}">
            <div>{{ item.userDataFirms[0] ? item.userDataFirms[0].firm.firmname1 : '' }}</div>
          </router-link>
        </td>
        <td>
          <phoneNumberLink :phoneNumber="item.mobilePhone"/>
        </td>
        <td>
          <a v-if="item.userEmail" :href="'mailto: ' + item.userEmail">{{ item.userEmail }}</a>
          <a v-if="item.contactEmail" :href="'mailto: ' + item.contactEmail">{{ item.contactEmail }}</a>
        </td>
        <td>
          {{ item.idClientType.title }}
        </td>
        <td v-if="displayWorkplace">
          <span v-if="item.workplace">{{ item.workplace.title }}</span>
        </td>
        <td v-if="displaySalesRepresentative">
          <span v-if="item.idSalesRepresentative">{{ item.idSalesRepresentative.name }} {{ item.idSalesRepresentative.surname }}</span>
        </td>
        <td>
          <slot v-bind:item="item"></slot>
        </td>
      </tr>
      </tbody>
    </table>
    <pagination
      v-if="view"
      :view="view"
      :totalItems="totalItems"
      @getPageNumber="getList($event.page, $event.itemsPerPage)">
    </pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  name: 'Table',
  props: {
    searchParams: {
      default: () => {}
    }
  },

  data () {
    return {
      selectedUsers: []
    }
  },

  components: {
    PhoneNumberLink,
    Pagination,
    Loader
  },

  watch: {
    searchParams: {
      deep: true,
      handler (val) {
        this.getList()
      }
    },
    selectedUsers () {
      this.$emit('selectedUsers', this.selectedUsers)
    }
  },

  computed: {
    displayWorkplace () {
      for (let i in this.items) {
        if (this.items[i].workplace) {
          return true
        }
      }
      return false
    },
    displaySalesRepresentative () {
      for (let i in this.items) {
        if (this.items[i].idSalesRepresentative) {
          return true
        }
      }
      return false
    },
    ...mapGetters({
      deletedItem: 'userdata/del/deleted',
      error: 'userdata/list/error',
      items: 'userdata/list/items',
      isLoading: 'userdata/list/isLoading',
      view: 'userdata/list/view',
      totalItems: 'userdata/list/totalItems'
    })
  },

  created () {
    this.getList()
  },

  methods: {
    ...mapActions({
      getPage: 'userdata/list/default'
    }),
    getList (pageNum = 1, itemsPerPage = undefined) {
      let params = Object.assign({}, this.searchParams)
      params['_page'] = pageNum
      params['itemsPerPage'] = itemsPerPage
      let url = addParamsToQuery('user_datas', params)
      this.getPage(url)
    }
  }
}
</script>

<style scoped>

</style>
